import { CustomerHistory, Tenant } from "../../types/apimodel";
import { TableRow, TableCell, Grid } from "@mui/material";
import React, { useState } from "react";
import { Button, Box } from "@mui/material";
import LinkedappBackend from "../../services/LinkedappBackend";

import { loadSessionData } from '../../util/store';
import { ReactComponent as OpenDocumentIcon } from '../../assets/images/opendocument.svg';

interface ReportingzeileProperties {
    row: CustomerHistory,
    tenant: Tenant | undefined;
}


function VsnrElement(props: ReportingzeileProperties) {
    let wert: String = "";

    if (props.row.vsnr) {
        wert = props.row.vsnr;
    }
    /*
    if (props.row.vsnr && props.row.schadennummer) {
        wert = wert + " / ";
    }
    if (props.row.schadennummer) {
        wert = wert + props.row.schadennummer;
    }
    */
    if (props.row.vcdocumenttile) {
        if (props.row.vsnr) {
            wert = wert + " / ";
        }
        wert = wert + props.row.vcdocumenttile;
    }
    return <Box component="span">{wert}</Box>

}

function ErstelldatumElement(props: ReportingzeileProperties) {
    let erstelldatum;
    if (props.row.erstelldatum && typeof props.row.erstelldatum == "string") {
        erstelldatum = new Date(props.row.erstelldatum).toLocaleDateString(undefined, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    }
    return <Box component="span">{erstelldatum}</Box>
}

// const scroll = (extid: string) => {
//     const section = document.querySelector("#detailsection-" + extid);
//     if (section !== null) {
//         section.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     }
// };


export default function Reportingzeile(props: ReportingzeileProperties) {
    let row: CustomerHistory = props.row;
    const [open] = useState<boolean>(false);


    const handleClick = (event: React.MouseEvent<unknown>, extid: string, tenant: Tenant | undefined) => {
        let cid = loadSessionData("cid");
        let url = "link/open?linkid=" + extid + "&cid=" + cid;
        LinkedappBackend.getLinkedAppLinkUrl(url);
    }

    const handleClickWelcomeLetter = (event: React.MouseEvent<unknown>, extid: string, tenant: Tenant | undefined) => {
        switch(String(tenant?.toString())){
            case "RHION" :
                window.open("/willkommen_rd.pdf");
                break;
            case "RHEINLAND":
                window.open("/willkommen.pdf");
                break;

            default :
                window.open("/willkommen.pdf");
                break;
        }
    }

    let paddingElemente = "7px";
    let paddingLeft = "17px";
    let buttonHeight = "27px";

    let rowRendered;
    if (row.belegart === 'WELCOMELETTER') {
        rowRendered = <TableRow
            sx={{ color: 'header.contrastText', "&:hover": { cursor: 'pointer' } }}
            hover={!open}
            onClick={(e) => handleClickWelcomeLetter(e, row.linkId, props.tenant)}
            tabIndex={-1}
            key={row.linkId}
        >
            <TableCell sx={{ display: { xs: 'table-cell', sm: 'table-cell', md: 'none', lg: 'none' } }}>
                <Grid container spacing={2} gridTemplateColumns="1fr" sx={{ display: 'grid', marginBottom: '1rem' }}>
                    <Grid item xs={12} sx={{ fontWeight: 'bold' }}>
                        <b>Willkommen in Ihrem Postfach</b>
                    </Grid>
                </Grid>
                <Button endIcon={<OpenDocumentIcon />} sx={{ fontSize: "75%" }}> Dokument öffnen</Button>
            </TableCell>

            <TableCell sx={{ display: { xs: 'none', sm: 'none', md: 'table-cell', lg: 'table-cell', padding: paddingElemente } }}>

            </TableCell>

            <TableCell sx={{ display: { xs: 'none', sm: 'none', md: 'table-cell', lg: 'table-cell', padding: paddingElemente } }}>

            </TableCell>

            <TableCell sx={{ display: { xs: 'none', sm: 'none', md: 'table-cell', lg: 'table-cell', padding: paddingElemente, paddingLeft: paddingLeft } }} colSpan={2}>
                <b>Willkommen in Ihrem Postfach</b>
            </TableCell>


            <TableCell sx={{ display: { xs: 'none', sm: 'none', md: 'table-cell', lg: 'table-cell', padding: paddingElemente } }} align="right" >
                <Button endIcon={<OpenDocumentIcon />} sx={{ fontSize: "75%", maxHeight: buttonHeight }}> Dokument öffnen</Button>
            </TableCell>

        </TableRow>;
    } else {
        rowRendered = <TableRow
            sx={{ color: 'header.contrastText', "&:hover": { cursor: 'pointer' } }}
            hover={!open}
            onClick={(e) => handleClick(e, row.linkId, props.tenant)}
            tabIndex={-1}
            key={row.linkId}
        >
            <TableCell sx={{ display: { xs: 'grid', sm: 'grid', md: 'none', lg: 'none' }}}>
                <Grid container spacing={1} sx={{ display: 'grid', marginBottom: '1rem', gridTemplateColumns: '11fr 1fr', width:'100%' }}>

                    <Grid item gridColumn={1} sx={{gridColumn: 'span 11'}}>
                        <ErstelldatumElement row={row} tenant={props.tenant} />
                    </Grid>

                    <Grid item gridColumn={1} sx={{ fontWeight: 'bold', gridColumn: 'span 11' }} >
                        {row.vcdocumenttile}
                    </Grid>
                    <Grid item gridColumn={12} sx={{ fontWeight: 'bold', height:'40px', width:'40px', alignContent:"flex-end" }} >
                        <Button sx={{padding:'0!important',marginTop:'0px',minHeight:'50px',minWidth:'50px'}}><OpenDocumentIcon name="Dokument öffnen" width={20} height={20} /></Button>
                        
                    </Grid>
                </Grid>
                 
                
            </TableCell>
            <TableCell sx={{ display: { xs: 'none', sm: 'none', md: 'table-cell', lg: 'table-cell', padding: paddingElemente, paddingLeft: paddingLeft } }}>
                <ErstelldatumElement row={row} tenant={props.tenant} />
            </TableCell>

            <TableCell sx={{ display: { xs: 'none', sm: 'none', md: 'table-cell', lg: 'table-cell', padding: paddingElemente, paddingLeft: paddingLeft } }}>
                {row.sparte}
            </TableCell>

            <TableCell sx={{ display: { xs: 'none', sm: 'none', md: 'table-cell', lg: 'table-cell', padding: paddingElemente, paddingLeft: paddingLeft } }}>
                <VsnrElement row={row} tenant={props.tenant} />
            </TableCell>

            <TableCell sx={{ display: { xs: 'none', sm: 'none', md: 'table-cell', lg: 'table-cell', padding: paddingElemente, paddingLeft: paddingLeft } }}>
                {row.risiko}
            </TableCell>

            <TableCell sx={{ display: { xs: 'none', sm: 'none', md: 'table-cell', lg: 'table-cell', padding: paddingElemente } }} align="right">
                <Button endIcon={<OpenDocumentIcon />} sx={{ fontSize: "75%", maxHeight: buttonHeight }}> Dokument öffnen</Button>
            </TableCell>

        </TableRow>;
    }


    return (
        <React.Fragment>
            {rowRendered}

        </React.Fragment>
    );
}